export default __webpack_public_path__ + "static/media/download.69e4cdd0.svg";